<template>
  <div>
    <import-dialog
      title="Import Contact List"
      :message="importMessage"
      :validate="true"
      :upload-url="uploadUrl"
      ref="fileUpload"
      v-if="showImportDialog"
      :visible="showImportDialog"
      @close="toggleImportDialog"
      style="font-size: 20px"
      @onSuccess="onImportSuccess"
    >
    </import-dialog>
    <v-tabs color="primary" slider-color="blue" dark v-model="tab">
      <v-tab v-for="i in 2" :key="i" :href="`#tab-${i}`">
        {{ getTabTitle(i) }}
      </v-tab>
    </v-tabs>
    <div style="position:absolute;top:20px;left:150px">
      <kendo-datepicker
        :value="asOfDate"
        :format="'MMM yyyy'"
        :start="'year'"
        :depth="'year'"
        style="width:108px"
        @change="asOfDatePickerChanged"
      ></kendo-datepicker>
      <v-btn title="Import ContactList" @click="toggleImportDialog" style="height:27px">
        <v-icon small>backup</v-icon>Import
      </v-btn>
    </div>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="i in 2" :key="i" :value="`tab-${i}`">
        <v-card flat>
          <v-card-text>
            <div v-if="i === 1">
              <contact-list-log :refresh="refresh" :asOfDate="asOfDate"></contact-list-log>
            </div>
            <div v-else-if="i === 2">
              <contact-list-match :asOfDate="asOfDate" :refresh="refresh"></contact-list-match>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import axios from 'axios'
import ContactListLog from '@/views/Report/ContactListLog'
import ContactListMatch from '@/views/Report/ContactListMatch'
import ImportDialog from '@/components/ImportDialog'
import notification from '@/helpers/notification'
import {mapGetters} from 'vuex'

export default {
  name: 'DashboardContactList',
  data() {
    return {
      tab: null,
      asOfDate: null,
      refresh: false,
      importMessage: '',
      showImportDialog: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const request = await axios
        .get('/api/report/monthlyReportSendingList/getLastDate')
        .catch(() => notification('Error ', 'error'))
      this.asOfDate = kendo.toString(request.data, 'yyyy-MM-dd')
      this.refresh = true
    },
    asOfDatePickerChanged(e) {
      this.asOfDate = kendo.toString(e.sender.value(), 'yyyy-MM-dd')
      this.refresh = !this.refresh
    },
    getTabTitle(i) {
      let title = ''
      switch (i) {
        case 1:
          title = 'Log'
          break
        case 2:
          title = 'Match'
          break
        default:
          title = ' '
          break
      }
      return title
    },
    onImportSuccess(e) {
      const vm = this
      if (e.status == 0) {
        vm.showImportDialog = false
        notification(e.message, 'info')
        this.refresh = !this.refresh
      } else {
        vm.importMessage = e.message
        notification(e.message, 'error')
      }
    },
    toggleImportDialog() {
      this.importMessage = ''
      this.showImportDialog = !this.showImportDialog
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    uploadUrl() {
      return '/api/report/monthlyReportSendingList/importContactList?reportDate=' + this.asOfDate
    },
  },
  components: {
    ContactListLog,
    ContactListMatch,
    ImportDialog,
  },
}
</script>
